import { TokenData } from '@/types/token-data'
export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  requiredPermissions?: string[]
  condition?: (user: TokenData | null) => boolean
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'MetabolicLang.navigationRoutes.home',
  },
  routes: [
    {
      name: 'backoffice-profile',
      displayName: 'MetabolicLang.menu.backofficeProfile',
      meta: {
        icon: 'manage_accounts',
      },
      requiredPermissions: ['backoffices::view'],
    },
    {
      name: 'nlh-list',
      displayName: 'MetabolicLang.menu.NLHs',
      meta: {
        icon: 'nlh',
      },
      requiredPermissions: ['menu::nlhs'],
    },
    {
      name: 'nlh-profile',
      displayName: 'MetabolicLang.menu.nlhProfile',
      meta: {
        icon: 'manage_accounts',
      },
      requiredPermissions: ['menu::nlh-profile'],
    },
    {
      name: 'executive-profile',
      displayName: 'MetabolicLang.menu.ExecutiveProfile',
      meta: {
        icon: 'manage_accounts',
      },
      requiredPermissions: ['menu::executive-profile'],
    },
    {
      name: 'executive-list',
      displayName: 'MetabolicLang.menu.ExecutiveList',
      meta: {
        icon: 'coach',
      },
      requiredPermissions: ['menu::executives'],
    },
    {
      name: 'coaches',
      displayName: 'MetabolicLang.menu.coaches',
      meta: {
        icon: 'coach',
      },
      requiredPermissions: ['menu::coaches'],
    },
    {
      name: 'coach-profile',
      displayName: 'MetabolicLang.menu.coachProfile',
      meta: {
        icon: 'manage_accounts',
      },
      requiredPermissions: ['menu::coach-profile'],
    },
    {
      name: 'clients-list',
      displayName: 'MetabolicLang.menu.patients',
      meta: {
        icon: 'clients',
      },
      requiredPermissions: ['menu::clients-list'],
    },
    {
      name: 'clients',
      displayName: 'MetabolicLang.menu.patients',
      meta: {
        icon: 'clients',
      },
      requiredPermissions: ['menu::clients'],
    },
    {
      name: 'client-progress',
      displayName: 'MetabolicLang.menu.client_progress',
      meta: {
        icon: 'straighten',
      },
      requiredPermissions: ['menu::progress'],
      condition: (user) => !!user?.patient_id,
    },
    {
      name: 'market-list',
      displayName: 'MetabolicLang.menu.MarketManagement',
      meta: {
        icon: 'globe',
      },
      requiredPermissions: ['menu::markets'],
    },
    {
      name: 'NLH-commercials',
      displayName: 'MetabolicLang.menu.Commercials',
      meta: {
        icon: 'commercials',
      },
      requiredPermissions: ['menu::commercials::nlh'],
    },
    {
      name: 'coach-commercials',
      displayName: 'MetabolicLang.menu.Commercials',
      meta: {
        icon: 'commercials',
      },
      requiredPermissions: ['menu::commercials::coach'],
    },
    {
      name: 'statistics',
      displayName: 'MetabolicLang.menu.Statistics',
      meta: {
        icon: 'description',
      },
      requiredPermissions: ['reports::statistics::view'],
    },
    {
      name: 'plans-verification',
      displayName: 'MetabolicLang.menu.plans_verification',
      meta: {
        icon: 'check',
      },
      requiredPermissions: ['menu::plan_verification'],
    },
    {
      name: 'laboratories',
      displayName: 'MetabolicLang.menu.laboratories',
      meta: {
        icon: 'laboratories',
      },
      requiredPermissions: ['menu::laboratories'],
    },
    {
      name: 'laboratories-admin',
      displayName: 'MetabolicLang.menu.laboratories',
      meta: {
        icon: 'laboratories',
      },
      requiredPermissions: ['menu::laboratories-admin'],
    },
    {
      name: 'food-converter',
      displayName: 'MetabolicLang.menu.FoodConverter',
      meta: {
        icon: 'converter',
      },
      requiredPermissions: ['menu::food_converter'],
    },
    {
      name: 'translations',
      displayName: 'MetabolicLang.menu.translations',
      meta: {
        icon: 'translate',
      },
      requiredPermissions: ['menu::translations'],
    },
    {
      name: 'browse',
      displayName: 'MetabolicLang.menu.plan_browse',
      meta: {
        icon: 'assignment',
      },
      requiredPermissions: ['menu::explore'],
      condition: (user) => !!user?.patient_id,
    },
    {
      name: 'coach-info',
      displayName: 'MetabolicLang.menu.coach_info',
      meta: {
        icon: 'account_box',
      },
      requiredPermissions: ['menu::coach_info'],
      condition: (user) => !!user?.patient_id,
    },
    // {
    //   name: '',
    //   displayName: 'MetabolicLang.menu.Commercials',
    //   meta: {
    //     icon: 'commercials',
    //   },
    //   requiredPermissions: ['menu::commercials::nlh'],
    //   children: [
    //     {
    //       name: 'NLH-commercials',
    //       displayName: 'MetabolicLang.menu.NLHCommercials',
    //       meta: {
    //         requiredPermissions: ['menu::commercials::nlh'],
    //       },
    //     },
    //     // {
    //     //   name: 'coach-commercials',
    //     //   displayName: 'MetabolicLang.menu.CoachCommercials',
    //     //   meta: {
    //     //     requiredPermissions: ['menu::commercials::coach'],
    //     //   },
    //     // },
    //   ],
    // },
  ] as INavigationRoute[],
}
